import '../../styles/templates/cart.scss';

/**
 * Submit form on Qty change
 */
 document.querySelectorAll(".product-details__input").forEach(function(el) {
  el.addEventListener("focusout", function(e) {
    theme.cart.updateCartPage();
  });
});

/**
 * Product remove
 */
document.querySelectorAll(".cart-product__remove").forEach(function(el) {
  el.addEventListener("click", function(e) {
    e.preventDefault();
    console.log("HERE");
    e.target.closest(".product-row").querySelectorAll(".product-qty__wrapper input").forEach(function(input) {
      input.value = 0;
    });
    theme.cart.updateCartPage();
    return false;
  });
});

/**
 * Change and submit cart form
 */
theme.cart.updateCartPage = () => {
  let data = []
  let subtotal = 0;
  document.querySelectorAll(".product-row").forEach(function(el) {
    let id = el.getAttribute("data-id");
    let price = el.getAttribute("data-price")
    let qty = 1;
    el.querySelectorAll(".product-qty__wrapper input").forEach(function(input) {
      if(theme.utils.isMobile() && !input.closest(".qty-mobile")) {
        return;
      }
      qty = input.value;
    });
    subtotal = subtotal + parseFloat(price) / 100 * qty;
    data.push(`updates[${id}]=${qty}`);
  });
  if(document.querySelector("[data-free-gift-id]")) {
    let gift_id = document.querySelector("[data-free-gift-id]").getAttribute("data-free-gift-id");
    let mini_free_gift_price = parseFloat(document.querySelector("[data-free-gift-id]").getAttribute("data-free-gift-mini-price")) / 100;
    if(subtotal < mini_free_gift_price) {
      data.push(`updates[${gift_id}]=0`);
    }
  }
  data = data.join("&");
  fetch('/cart/update.js', {
    method: 'POST',
    body: data,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(function(data) {
    if (data.status === 422) {
      console.log(data);
    } else {
      window.location.reload();
    }
  });
}
